var _defs, _rect, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSbiLogo = function SvgSbiLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    viewBox: "0 0 241 241",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n\n      .st1 {\n        fill: #ff7300;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 241,
    height: 241
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179,109c2.6-4.6,4.1-9.9,4.1-15.6,0-17.7-14.4-32.1-32.2-32.1h-49.8v42.7c7.2,2.9,13.4,7.9,18,14.2,1.8,2.2,3.4,4.6,4.6,7.2h3.4s0,0,0,0h35.2c8.4.8,15.1,7.9,15.1,16.5s-6.6,15.6-15.1,16.4h0c0,0-38.8,0-38.8,0-.7,1.4-1.6,2.8-2.5,4.1-4.5,7.7-11.3,13.7-19.4,17.1h59.3c20.9,0,37.8-16.9,37.8-37.6s-7.9-26.7-19.7-33h0ZM151.1,104.1h-28.7v-21.3h28.7c5.9,0,10.7,4.8,10.7,10.7s-4.8,10.7-10.7,10.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M119.5,158.9c2.5-5.1,4-10.8,4-16.9s-1.4-11.5-3.8-16.5c-4.5-9.3-12.6-16.4-22.6-19.5-3.5-1.1-7.2-1.7-11-1.7s-31,0-31.1,0c-5.9,0-10.7-4.8-10.7-10.8s4.8-10.8,10.7-10.8h0s31.6,0,31.6,0v-21.5h-32c-17.5.2-31.6,14.6-31.6,32.3s13,30.8,29.5,32.1c0,0,33.7,0,33.7,0h0c4.3,0,8.1,1.7,11,4.4,3.1,2.9,5,7.1,5,11.7s-1.9,8.8-5,11.7c-2.9,2.7-6.7,4.4-11,4.4H22.9v21.6h63.2c3.8,0,7.5-.6,11-1.7,9.8-3,17.8-10,22.4-19.1h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M218.1,61.3h-21.4v61.4c3.1,5.8,4.9,12.4,4.9,19.3s-1.8,13.5-4.9,19.3v18.3h21.4s0-118.3,0-118.3Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSbiLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sbi-logo.20b55745.svg";
export { ForwardRef as ReactComponent };